import classnames from 'classnames';
import { FC, PropsWithChildren, ReactNode } from 'react';

export const WithCountryFlag: FC<PropsWithChildren<{ className?: string; content?: ReactNode }>> = ({
  className,
  children,
  content,
}) => {
  if (content === undefined) {
    return <>{children}</>;
  }
  return (
    <div className={classnames('input-group', className)}>
      <span className="input-group-text">{content}</span>
      {children}
    </div>
  );
};

WithCountryFlag.displayName = 'WithCountryFlag';
